import '../styles/global.css';
import '@fillout/react/style.css';
import 'video.js/dist/video-js.min.css';
import '../components/VideoJS/vjs-vodafone.css';
import i18n from '../utils/Localization';
import { I18nextProvider } from 'react-i18next';
import type { AppProps } from 'next/app';
import Layout from '@/pages/layout';
import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { Log } from '@/logging/datadog';

function MyApp({ Component, pageProps /*, ...rest*/ }: AppProps) {
  useEffect(() => {
    const token = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;
    if (!token) {
      return;
    }
    const site = process.env.NEXT_PUBLIC_DD_SITE || 'datadoghq.eu';
    datadogLogs.init({
      clientToken: token,
      site,
      service: process.env.NEXT_PUBLIC_DD_SERVICE || 'syn-web',
      env: process.env.NEXT_PUBLIC_DD_ENV || process.env.NODE_ENV || 'production',
      // Use the same release id as sourcemap upload: set in build script from DD_VERSION or VERCEL_GIT_COMMIT_SHA
      version: process.env.NEXT_PUBLIC_DD_VERSION || 'dev',
      forwardErrorsToLogs: true,
      // Forward console errors in dev to make testing easier
      forwardConsoleLogs: ['error', 'warn'],
      sessionSampleRate: 100,
    });
    /** Global event listeners */
    window.addEventListener('unhandledrejection', (ev) =>
      Log.error('unhandledrejection', { reason: String(ev.reason) })
    );
    window.addEventListener('error', (e) => Log.error('window.error', { message: e.message, stack: e.error?.stack }));
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </I18nextProvider>
  );
}

export default MyApp;
